<template>
  <div>
    <h1 class="light">Recent Users List</h1>

    <div class="row">
      <div class="col-md-2">
        <label for="recentUsersPoduct">Product</label>
        <select
          id="recentUsersPoduct"
          v-model="filters.product"
          @change="getUsersList"
          class="form-control">
          <option value="toolkit">Toolkit</option>
          <option value="pathways">Pathways</option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="recentUsersLicenseType">License Type</label>
        <select
          id="recentUsersLicenseType"
          v-model="filters.licenseType"
          @change="getUsersList"
          class="form-control">
          <option value="trial">Trial</option>
          <option value="premium">Enterprise</option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="recentUsersActiveIn">Active In</label>
        <select
          id="recentUsersActiveIn"
          v-model="activeIn"
          @input="setStartAndEndDates"
          class="form-control">
          <option :value="30">Last 30 Days</option>
          <option :value="60">Last 60 Days</option>
          <option :value="90">Last 90 Days</option>
          <option :value="365">Last Year</option>
          <option :value="365*5">Last 5 Years</option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="recentUsersTitle">Title</label>
        <input
          id="recentUsersTitle"
          type="text"
          class="form-control"
          v-model="filters.title"
          @input="throttledGetUsersList">
      </div>
      <div class="col-md-2">
        <label for="recentUsersDistrict">District</label>
        <input
          id="recentUsersDistrict"
          type="text"
          class="form-control"
          v-model="filters.district"
          @input="throttledGetUsersList">
      </div>
      <div class="col-md-2">
        <label for="recentUsersState">State</label>
        <input
          id="recentUsersState"
          type="text"
          class="form-control"
          v-model="filters.state"
          @input="throttledGetUsersList">
      </div>
    </div>
    <br>

    <p class="text-muted" v-if="loading">
      <i class="fa fa-spinner fa-spin"/> Loading users list...
    </p>

    <div class="alert alert-danger" v-else-if="error">
      <h4>Error Loading Users List</h4>
    </div>

    <v-client-table
      v-if="userList.length > 0"
      ref="recentUsersTable"
      :data="userList"
      :columns="eventsTableColumns"
      :options="eventsTableOptions"
      @sorted="throttledGetUserEventCounts"
      @pagination="throttledGetUserEventCounts"
    >
      <b slot="name" slot-scope="props">
        <a :href="`#!/user_events?uuid=${props.row.uuid}`" target="_blank">{{ props.row.name }}</a>
      </b>
      <div slot="email" slot-scope="props">
        {{ props.row.email }}
      </div>
      <div slot="title" slot-scope="props">
        {{ props.row.title }}
      </div>
      <div slot="district" slot-scope="props">
        {{ props.row.district }}
      </div>
      <div slot="state" slot-scope="props">
        {{ props.row.state }}
      </div>
      <div :slot="'tk_last_active' " slot-scope="props">
        {{ props.row.tk_last_active ? (new Date(props.row.tk_last_active)).toLocaleDateString('en-US') : '' }}
      </div>
      <div slot="pw_last_active" slot-scope="props">
        {{ props.row.pw_last_active ? (new Date(props.row.pw_last_active)).toLocaleDateString('en-US') : '' }}
      </div>
      <div slot="event_count" slot-scope="props">
        <i v-if="loadingEventCounts && !userEventCounts[props.row.uuid]" class="fa fa-spinner fa-spin"/>
        {{ userEventCounts[props.row.uuid] }}
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { ClientTable } from 'vue-tables-2'
import Vue from 'vue'
Vue.use(ClientTable)

export default {
  name: 'UsersList',
  data() {
    return {
      error: false,
      loading: false,
      loadingEventCounts: false,
      userList: [],
      activeIn: 30,
      filters: {
        database: 'rds',
        product: 'toolkit',
        licenseType: 'trial',
        title: '',
        district: '',
        state: ''
      },
      // Table options
      eventsTableColumns: [
        'name',
        'email',
        'title',
        'district',
        'state',
        'tk_last_active',
        'pw_last_active',
        'event_count'
      ],
      userEventCounts: {},
      eventsTableOptions: {
        headings: {
          name: 'Name',
          email: 'Email',
          title: 'Title',
          district: 'District',
          tk_last_active: 'Toolkit Last Active',
          pw_last_active: 'Pathways Last Active',
          event_count: '# of Events'
        },
        sortable: ['name', 'email', 'title', 'district', 'state', 'tk_last_active', 'pw_last_active'],
        orderBy: {
          ascending: false,
          column: 'tk_last_active'
        },
        perPage: 100,
        filterable: false
      }
    }
  },
  methods: {
    throttledGetUsersList: _.debounce(function() {
      this.getUsersList()
    }, 1000),
    throttledGetUserEventCounts: _.debounce(function() {
      this.getUserEventCounts()
    }, 1000),
    getUsersList() {
      this.loading = true
      this.$angularWorld.analyticsApi
        .getAnalyticsReport('recent_users_list', this.filters)
        .then(report => {
          this.loading = false
          this.error = null
          this.userList = report[0].Report
          setTimeout(this.getUserEventCounts, 0)
        })
        .catch(error => {
          this.error = error
          this.loading = false
        })
    },
    getUserEventCounts() {
      this.loadingEventCounts = true
      var uuidList = this.$refs.recentUsersTable.filteredData.map(row => {
          return row.uuid
        }).filter(uuid => {
          return !this.userEventCounts[uuid]
        })
      if (uuidList.length > 0) {
        this.$angularWorld.analyticsApi.getUserEventCounts(uuidList)
          .then(counts => {
            this.userEventCounts = Object.assign(this.userEventCounts, counts)
            this.loadingEventCounts = false
            this.$forceUpdate()
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    setStartAndEndDates(activeIn) {
      let now = new Date()
      this.filters.edate = `${now.getFullYear()}-${new String(now.getMonth() + 1).padStart(
        2,
        '0'
      )}-${new String(now.getDate()).padStart(2, '0')}`

      let daysAgo = new Date()
      daysAgo.setDate(now.getDate() - this.activeIn)
      this.filters.sdate = `${daysAgo.getFullYear()}-${new String(daysAgo.getMonth() + 1).padStart(
        2,
        '0'
      )}-${new String(daysAgo.getDate()).padStart(2, '0')}`
    }
  },
  created() {
    this.setStartAndEndDates(this.activeIn)
    this.getUsersList()
  },
  watch: {
    activeIn(newActiveIn) {
      this.setStartAndEndDates(newActiveIn)
      this.getUsersList()
    },
    'filters.product': function(newProduct) {
      if (newProduct === 'toolkit') {
        this.$refs.recentUsersTable.setOrder('tk_last_active', false)
      } else {
        this.$refs.recentUsersTable.setOrder('pw_last_active', false)
      }
    }
  }
}
</script>

<style scoped>
</style>
